"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var react_final_form_1 = require("react-final-form");
var swr_hooks_1 = require("@l2p/swr-hooks");
var play_api_1 = require("@l2p/play-api");
var BonusConditions_1 = __importDefault(require("../BonusConditions"));
var BonusConditionsContent_1 = __importDefault(require("../CurrentLotteryCard/BonusConditionsContent"));
var DepositLotteryInfo = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var t = (0, next_intl_1.useTranslations)('lottery');
    var data = (0, swr_hooks_1.useLotteries)().data;
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var formState = (0, react_final_form_1.useFormState)();
    var _h = (0, react_1.useState)(false), isOpenInfo = _h[0], setIsOpenInfo = _h[1];
    var activeLottery = (0, react_1.useMemo)(function () {
        if (!data)
            return null;
        return data === null || data === void 0 ? void 0 : data.find(function (lottery) { return lottery.status === play_api_1.LotteryStatusEnum.Active; });
    }, [data]);
    var ticketPrice = (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.baseLottery) === null || _a === void 0 ? void 0 : _a.depositSettings) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.currency === currentCurrency; })) === null || _c === void 0 ? void 0 : _c.price;
    }, [currentCurrency, (_a = activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.baseLottery) === null || _a === void 0 ? void 0 : _a.depositSettings]);
    var lotteryTitle = (0, react_1.useMemo)(function () { var _a; return translateLocale((_a = activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.baseLottery) === null || _a === void 0 ? void 0 : _a.title); }, [translateLocale, (_b = activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.baseLottery) === null || _b === void 0 ? void 0 : _b.title]);
    if (!activeLottery || !(activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.canParticipate) || !lotteryTitle)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container, style: {
                background: "url(".concat((_d = (_c = activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.baseLottery) === null || _c === void 0 ? void 0 : _c.images) === null || _d === void 0 ? void 0 : _d.banner, ") top center no-repeat"),
                backgroundSize: 'cover',
            } },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.overlay }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, "".concat(lotteryTitle, ": ").concat(t('ticketsYouWillGet', {
                    amount: "".concat(Math.floor((((_e = formState === null || formState === void 0 ? void 0 : formState.values) === null || _e === void 0 ? void 0 : _e.amount) || 1) / Number(ticketPrice || 1))),
                }))),
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.info, " details-info"), onClick: function () { return setIsOpenInfo(true); } },
                    react_1.default.createElement("img", { src: "/img/icons/infoRound.svg", alt: "info" })))),
        isOpenInfo && (react_1.default.createElement(BonusConditions_1.default, { onClose: function () { return setIsOpenInfo(false); } },
            react_1.default.createElement(BonusConditionsContent_1.default, { bonusConditions: (_g = (_f = activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.baseLottery) === null || _f === void 0 ? void 0 : _f.descriptions) === null || _g === void 0 ? void 0 : _g.long })))));
};
exports.default = DepositLotteryInfo;
